module.exports = __webpack_public_path__ + "media/images/ohap_ui_plus_outline_off-5d9f304178f5b3d8991d58409b2584ea.png";